<template>
	<div>
		<div v-if="type=='list1'">
			<van-sticky>
				<div :style="'background: '+background+';'">
					<div class="navi_back">
						<div @click="pageBack()" class="navi_back_drop">
							<div class="navi_back_drop_icon">
								<img src="../resource/back.png" alt="" />
							</div>
						</div>
						<div class="navi_back_title">{{title}}</div>
					</div>
				</div>
			</van-sticky>
		</div>
		<div v-if="type=='list2'">
			<van-sticky>
				<div :style="'background: '+background+';'">
					<div class="navi_back2 width_100 display_between_center">
						<div class="navi_back2_left display_center_center">
							<div v-if="search_params" @click="openCityPop()" class="navi_back2_left_item display_center_center">
								<div class="width_fit text_ellipsis font_size_26 color_666666">{{search_params.city_name?search_params.city_name:'--'}}</div>
								<img src="../resource/drop_down.png" alt="" />
							</div>
							<div v-if="search_params" @click="openDistrictPop()" class="navi_back2_left_item display_center_center">
								<div class="width_fit text_ellipsis font_size_26 color_666666">{{search_params.district_name?search_params.district_name:'--'}}</div>
								<img src="../resource/drop_down.png" alt="" />
							</div>
						</div>
						<div class="navi_back2_right width_fit display_center_center">
							<input v-model="key_words" @blur="filterToSearch" type="text" class="color_333333 font_size_26" placeholder="搜索酒店、场馆" />
							<button class="font_size_24 color_ffffff width_fit text_ellipsis2">搜索</button>
						</div>
					</div>
				</div>
			</van-sticky>
			<popCity ref="popCity" @selectCityDistrict="selectCityDistrict" />
			<popDistrict ref="popDistrict" :search_params="search_params" @selectDistrict="selectDistrict" />
		</div>
		<div v-if="type=='detail'">
			<div class="navi_back3" :style="'background: '+background+';'">
				<div class="navi_back">
					<div @click="pageBack()" class="navi_back_drop">
						<div class="navi_back_drop_icon">
							<img src="../resource/back_ffffff.png" alt="" />
						</div>
					</div>
					<div class="navi_back_title">{{title}}</div>
				</div>
			</div>
		</div>
		<div v-if="type=='time_table'">
			<van-sticky>
				<div :style="'background: '+background+';'">
					<div class="navi_back">
						<div @click="pageBack()" class="navi_back_drop">
							<div class="navi_back_drop_icon">
								<img src="../resource/back.png" alt="" />
							</div>
						</div>
						<div class="navi_back_title">{{title}}</div>
					</div>
					<div class="navi_back4 width_100">
						<div class="width_fit text_ellipsis2 display_start_center">
							<div v-for="(item_date,index_index) in 14" :key="'timetable'+index_index" 
							:class="[{'color_F77F28 navi_back4_itemS':index_index==0},{'color_666666':index_index!=0},'navi_back4_item border_radius_8 text_align_center display_center_center']">
								<div>
									<div class="navi_back4_item_1 font_size_28 font_weight_600">周一</div>
									<div class="navi_back4_item_2 font_size_20">12.12</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</van-sticky>
		</div>
		
	</div>
</template>

<script>
	import popCity from './pop_city.vue';
	import popDistrict from './pop_district.vue';
	export default {
		components: {
			popCity,popDistrict
		},
		props: {
			title: {
				type: String,
			},
			type: {
				type: String,
				required: true
			},
			background: {
				type: String,
			},
			search_params:{
				type: Object,
			}
		},
		data() {
			return {
				temp_data:{},
				key_words:''
			}
		},
		mounted() {},
		methods: {
			pageBack() {
				this.$router.go(-1)
			},
			
			// 城市pop
			openCityPop(){
				this.$refs.popCity.openCityPop()
			},
			selectCityDistrict(e){
				// console.log('选择区域',e);
				this.temp_data=e
				this.filterToSearch()
			},
			
			// 区域pop
			openDistrictPop(){
				this.$refs.popDistrict.getDistrictList()
			},
			selectDistrict(e){
				this.temp_data=e
				this.filterToSearch()
			},
			// 参数整理完毕，传值给父组件
			filterToSearch(){
				var params=this.temp_data
				params.key_words=this.key_words
				this.$emit('filterToSearch',params)
			},
			
		}
	}
</script>

<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.navi_back {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;

		.navi_back_drop {
			width: fit-content;
			padding: 0 30*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;
		}

		.navi_back_drop_icon {
			width: fit-content;
			height: 80*@vm_base;
			display: flex;
			justify-content: flex-start;
			align-items: center;

			img {
				width: 30*@vm_base;
			}
		}

		.navi_back_title {
			width: calc(100% - 180*@vm_base);
			font-size: 32*@vm_base;
			color: #333;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
	.navi_back2{
		padding: 20*@vm_base 30*@vm_base;
		.navi_back2_left{
			.navi_back2_left_item{
				margin-right: 30*@vm_base;
				&:last-child{
					margin-right: 0;
				}
				img{
					width: 22*@vm_base;
					margin-left: 10*@vm_base;
				}
				div{
					max-width: 110*@vm_base;
					line-height: calc(50 / 26);
				}
			}
		}
		.navi_back2_right{
			padding: 4*@vm_base;
			border: 1*@vm_base solid #D9D9D9;
			border-radius: 50*@vm_base;
			overflow: hidden;
			input{
				width: 270*@vm_base;
				height: 50*@vm_base;
				border: none;
				padding-left: 64*@vm_base;
				background-repeat: no-repeat;
				background-image: url(../resource/search.png);
				background-size: 30*@vm_base;
				background-position: 20*@vm_base center;
			}
			button{
				background: #F77F28;
				border-radius: 23*@vm_base;
				border: none;
				padding: 10*@vm_base 20*@vm_base;
				&::after{
					border: none;
					outline:none
				}
			}
		}
	}
	.navi_back3{
		position: fixed;
		top: 0;
		left: 0;
		z-index: 99;
	}
	.navi_back4{
		padding: 0 0 30*@vm_base 0;
		overflow: hidden;
		overflow-x: auto;
		&::-webkit-scrollbar{
			width: 0;
			height: 0;
		}
		.navi_back4_item{
			width: 110*@vm_base;
			height: 90*@vm_base;
			border: 1*@vm_base solid #d9d9d9;
			margin-right: 20*@vm_base;
			&:first-child{
				margin-left: 30*@vm_base;
			}
			&:last-child{
				margin-right: 30*@vm_base;
			}
			.navi_back4_item_1{
				line-height: calc(38 / 28);
			}
			.navi_back4_item_2{
				line-height: calc(30 / 20);
			}
		}
		.navi_back4_itemS{
			border: 1*@vm_base solid #F77F28
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/navi_back.vue